/* fetch() has no timeout - a server or API that never answers left the login spinner running forever.
   fetchWithTimeout aborts the request (including reading the body) after timeoutMs and returns a
   response-like object { ok, status, statusText, headers, json(), text() } with the body already read. */
export const FETCH_TIMEOUT_MS = 30000
export const FETCH_LONG_TIMEOUT_MS = 300000

export async function fetchWithTimeout(
  url,
  options = {},
  timeoutMs = FETCH_TIMEOUT_MS
) {
  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), timeoutMs)
  try {
    const response = await fetch(url, { ...options, signal: controller.signal })
    const text = await response.text()
    return {
      ok: response.ok,
      status: response.status,
      statusText: response.statusText,
      headers: response.headers,
      json: async () => JSON.parse(text),
      text: async () => text
    }
  } finally {
    clearTimeout(timer)
  }
}

/* Error fields for a failed fetch: marks aborted (timed out) requests with timeout: true */
export function fetchErrorFields(error) {
  if (error?.name === 'AbortError') {
    return { timeout: true, errorMsg: 'Request timed out' }
  }
  return { errorMsg: String(error) }
}
